<template>
  <vs-avatar :src="avatar" :size="size" />
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: () => '30px'
    }
  },
  data() {
    return {
      avatar: null
    }
  },
  created() {
    if (!this.id) return
    this.$store.dispatch('file/downloadFile', this.id).then(response => {
      this.avatar = response
    })
  }
}
</script>
